import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("RESPONSE")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("SELECT REQUEST RESPONSE")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Approve ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Reject ")
const _hoisted_5 = {
  key: 0,
  class: "raw-data-request-response-rejection-message"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("REJECTION MESSAGE")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("sup", { class: "red-color" }, "*", -1)
const _hoisted_8 = { class: "raw-data-request-reject-guide font-reg font-12" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Rejection Message Guidelines")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Please note that this rejection message will be viewed by the user who submitted the raw data request.", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "When writing this message it is important to include the reason why the raw data request is being rejected. ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "Example for reasons for rejection: ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", null, "User has provided insufficient information"),
  /*#__PURE__*/_createElementVNode("li", null, "Survey selection does not match research description"),
  /*#__PURE__*/_createElementVNode("li", null, "Research topic already explored by another user")
], -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Confirm Response")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Option = _resolveComponent("Option")!
  const _component_CaretDownFilled = _resolveComponent("CaretDownFilled")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Title, { level: 4 }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      _createElementVNode("div", null, [
        _createVNode(_component_Title, {
          level: 5,
          style: _normalizeStyle({ fontSize: '0.75rem'})
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["style"]),
        _createVNode(_component_Select, {
          value: _ctx.response,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.response) = $event)),
          placeholder: "Select",
          size: "large",
          bordered: false,
          class: "raw-data-request-response-select font-reg",
          style: {"color":"'#363534'"}
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_CaretDownFilled, {
              style: {"color":"#333333"},
              class: "pointer-events-none"
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Option, { value: "approved" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_Option, { value: "rejected" }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      (_ctx.response === 'rejected')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("span", null, [
              _createVNode(_component_Title, {
                level: 5,
                style: _normalizeStyle({ fontSize: '0.75rem'})
              }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["style"]),
              _withDirectives(_createElementVNode("textarea", {
                class: "raw-data-request-detail-text-area font-reg",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.message) = $event)),
                placeholder: "Placeholder"
              }, "\n          ", 512), [
                [_vModelText, _ctx.message]
              ])
            ]),
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_Title, {
                level: 5,
                style: _normalizeStyle({ fontSize: '0.75rem', fontWeight: 500 }),
                class: "font-med"
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["style"]),
              _hoisted_10,
              _hoisted_11,
              _hoisted_12,
              _hoisted_13
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.response !== undefined ? '' : 'not-allowed-cursor'])
      }, [
        _createVNode(_component_Button, {
          type: "primary",
          class: _normalizeClass([(_ctx.response === 'approved') || (_ctx.response === 'rejected' && _ctx.message !== '') ? '' : 'raw-data-request-detail-btn-disable', 'font-med', 'font-16']),
          style: {"marginTop":"1rem"},
          size: "large",
          onClick: _ctx.confirmResponse
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }, 8, ["class", "onClick"])
      ], 2)
    ])
  ]))
}